import { createSlice } from '@reduxjs/toolkit';
import { postVehicleList, postVehicleCount } from './thunks';

const initialState = {
  list: {
    pageIndex: 0,
    totalRecords: 50,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  loading: 'idle',
  loadingCount: 'idle',
  error: null,
};

const vehicleSlice = createSlice({
  name: 'vehicles',
  initialState,
  reducers: {
    clearVehicleError: (state) => {
      state.error = null;
    },
    setVehicleFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
  extraReducers: {
    [postVehicleList.pending]: (state) => {
      state.loading = 'loading';
      state.error = null;
    },
    [postVehicleList.fulfilled]: (state, action) => {
      state.loading = 'succeeded';
      state.list.elements = action.payload.elements;
    },
    [postVehicleList.rejected]: (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    },
    [postVehicleCount.pending]: (state) => {
      state.loadingCount = 'loading';
      state.error = null;
    },
    [postVehicleCount.fulfilled]: (state, action) => {
      state.loadingCount = 'succeeded';
      state.list.pageIndex = action.payload.pageIndex;
      state.list.totalRecords = action.payload.totalRecords;
      state.list.totalPages = action.payload.totalPages;
      state.list.hasPreviousPage = action.payload.hasPreviousPage;
      state.list.hasNextPage = action.payload.hasNextPage;
    },
    [postVehicleCount.rejected]: (state, action) => {
      state.loadingCount = 'failed';
      state.error = action.error.message;
    },
  },
});

export const { clearVehicleError, setVehicleFilters } = vehicleSlice.actions;

export default vehicleSlice.reducer;
